/**
 * 卡片模块公共类型定义
 */

// 卡片业务状态枚举（对应后端 Status 枚举）
export const CardStatus = {
  Active: 'active',           // 已激活
  Closed: 'closed',           // 已关闭
  Expired: 'expired',         // 已过期
  Frozen: 'frozen',           // 已冻结
  Locked: 'locked',           // 已锁定
  Pending: 'pending',         // 开卡中
  PendingActivation: 'pending_activation', // 开卡成功待激活
  KycPending: 'kyc_pending',  // KYC审核中
  Submitted: 'submitted',     // 已提交
  KycFailed: 'kyc_failed',    // KYC失败
  ApplicationError: 'application_error', // 申请错误
  KycPassed: 'kyc_passed',    // KYC通过
  Binded: 'binded',          // 已绑定
} as const

export type CardStatusType = typeof CardStatus[keyof typeof CardStatus]

// 已下卡的业务状态（这些状态的卡已经发卡，可以展示卡号和余额）
export const ISSUED_CARD_STATUSES = [
  CardStatus.Active,
  CardStatus.Frozen,
  CardStatus.Expired,
  CardStatus.Closed,
  CardStatus.Locked,
] as const

export type IssuedCardStatus = typeof ISSUED_CARD_STATUSES[number]

// 判断是否是已下卡状态
export const isIssuedStatus = (status?: string): boolean => {
  return status ? (ISSUED_CARD_STATUSES as readonly string[]).includes(status) : false
}

